/**
 * AIFileUploadV2RouteSkeleton — loading skeleton for the AIFileUploadV2 mobile layout (AC-2.8).
 *
 * Matches the 402px mobile-first design:
 *  - Off-white background
 *  - Header skeleton
 *  - List of file card skeletons
 */
import { FC } from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

const MOBILE_WIDTH = 402;

const AIFileUploadV2RouteSkeleton: FC = () => (
  <Box
    sx={{
      maxWidth: MOBILE_WIDTH,
      width: '100%',
      mx: 'auto',
      backgroundColor: 'background.neutral',
      minHeight: '100%',
    }}
  >
    {/* Header */}
    <Skeleton
      variant="rectangular"
      height={60}
      animation="wave"
      sx={{ mb: 1 }}
    />

    <Stack gap={2} sx={{ px: 2, pt: 2 }}>
      {/* Summary bar */}
      <Skeleton variant="rounded" height={56} animation="wave" />

      {/* File cards */}
      {[1, 2, 3].map((i) => (
        <Skeleton key={i} variant="rounded" height={88} animation="wave" />
      ))}
    </Stack>
  </Box>
);

export default AIFileUploadV2RouteSkeleton;
